import { Component} from '@angular/core';
import { AuthService } from './shared/utils/services/auth.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { LoadingService } from './shared/components/loading/loading.service';
import { RestService } from './shared/utils/services/rest.service';
import { ParametrosService } from './shared/utils/services/parametros.service';
import { environment } from 'src/environments/environment';
import { Routes } from './shared/utils/enums/route.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public authAdm = false;
  private readonly PATH = environment.rotaCasal;
  private readonly BANNER_TOP = environment.bannerTop;

  constructor(
    private authService: AuthService,
    private router: Router,
    private loadingService: LoadingService,
    private restService: RestService,
    private parametrosService: ParametrosService
  ) { 
    // window.addEventListener('load', () => {
    //   this.loadingService.disactive();
    // });
    
    if (!this.parametrosService.isCriarNovoBancoDeDados) {
      this.iniciaSistema();
    } else {
      console.log('Nova Rota iniciada');
      this.parametrosService.criaNovoBancoDeDados();
    }
  }

  ngOnInit(): void {
    if (!this.parametrosService.isCriarNovoBancoDeDados) {
      const subscription: Subscription = this.authService.authenticatedAdm$.subscribe(result => {
        if (result) {
          this.authAdm = result;
          subscription.unsubscribe();
        }
      });
    }
  }

  private iniciaSistema(): void {
    const subscriber = this.restService.getCoupleData().subscribe((coupleData: any) => {
      const data = {
        ...coupleData[0],
        coupleName: `${coupleData[0].noivoName} ${coupleData[0].noivaName}`,
        routePath: this.PATH,
        bannerTop: this.BANNER_TOP
      }
      console.log('data: ', data);
      this.authService.setParameters(data);

      if (this.parametrosService.getSistema().rotaInicial !== Routes.LOGIN) {
        this.router.navigate([this.parametrosService.getSistema().rotaInicial]);
      }

      // if (window.location.pathname !== '/adm') {
      //   if (data.routePath) {
      //     this.router.navigate([data.routePath]);
      //   }
      // }
      this.loadingService.disactive();
      subscriber.unsubscribe();
    }, err => {
      this.loadingService.disactive();
      alert('Erro ao consultar banco de dados. Tente novamente mais tarde.')
      subscriber.unsubscribe();
    });
  }

}
